var $;
var MASTER = {
    Construct: function(jquery) { $ = jquery; },
    Mobile: { _mobile: false },
    Numbers: {
        PlaceValue: function(number) {
            if (number < 999999 && number > 99999) {
                return `${(number / 1000).toFixed(0)}K`;
            } else if (number > 999999 && number < 1000000000) {
                return this.Format(number, 1000000, "M");
            } else if (number > 1000000000 && number < 1000000000000) {
                return this.Format(number, 1000000000, "B");
            } else {
                if (number > 0) {
                    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            }
            return "";
        },
        Format: function(number, divideBy, place) {
            let value = (number / divideBy).toFixed(2) + "";
            if (value.indexOf(".00") !== -1) {
                return `${value.replace(".00", "")}${place}`;
            }
            return `${value}${place}`;
        }
    },
    Platform: {
        _desktop: false,
        _mobile: false,
        Construct: function() {
            this._desktop = window.getComputedStyle(document.getElementById("desktop"), null).display === "block";
            this._mobile = window.getComputedStyle(document.getElementById("mobile"), null).display === "block";
        }
    },
    Lists: {
        UniqueFromObject: function(array, orderBy) {
            return [ ...new Map(array.map(a =>[a[orderBy], a])).values() ];
        },
        Unique: function(value, index, array) {
            return array.indexOf(value) === index;
        }
    }
};

class ScrollAction {
    $referenceElement = null;
    instance = null;
    position = {};
    constructor(element, spaceAbove, position) {
        this.$referenceElement = $(element);
        const instance = this;
        this.position = position;
        $(window).on("scroll", function() {
            if ($("html").scrollTop() >= spaceAbove) {
                instance.Action.Active(instance);
            } else {
                instance.Action.Inactive(instance);
            }
        });
    };
    Action = {
        Active: function(ScrollAction) {
            const style = {
                position: "fixed",
                "z-index": 100
            };
            const { position, padding } = ScrollAction.position;
            if (position === "Left") {
                style.left = `${padding}px`;
            } else { // Right
                style.right = `${padding}px`;
            }
            ScrollAction.$referenceElement.css(style);
            if (!MASTER.Mobile._mobile) {
                ScrollAction.$referenceElement.css("top", "50%");
            }
        },
        Inactive: function(ScrollAction) {
            ScrollAction.$referenceElement.css("position", "inherit");
        }
    };
};

class FormattedDate {
    output = "";
    singleOutput = "";
    formatType = "";
    constructor(formatType, start, end) {
        this.formatType = formatType;
        this.output = `${this.Format(start)} - ${this.Format(end)}`;
        if (!end) {
            this.singleOutput = `${this.Format(start)}`;
        }
    }
    Format = function(date) {
        date = new Date(date);
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const year = date.getFullYear();
        if (month.length < 2) {
            month = "0" + month;
        }
        if (day.length < 2) {
            day = "0" + day;
        }
        if (this.formatType === "Simple") {
            return `${month}/${day}/${year}`;
        } else if (this.formatType === "Two Part") {
            return `${this.GetMonth(month)}, ${year}`;
        } else if (this.formatType === "Descriptive") {
            return `${this.GetMonth(month)} ${day}, ${year}`;
        } else if (this.formatType === "Month") {
            return this.GetMonth(month);
        }
    };
    GetMonth = function(monthNumber) {
        switch(monthNumber) {
            case 1: return "January";
            case 2: return "February";
            case 3: return "March";
            case 4: return "April";
            case 5: return "May";
            case 6: return "June";
            case 7: return "July";
            case 8: return "August";
            case 9: return "September";
            case 10: return "October";
            case 11: return "November";
            case 12: return "December";
        }
    };
    DayName = function() {
        return date.toLocaleDateString("en-US", { weekday: "long" });
    }
};

module.exports = {
    MASTER,
    ScrollAction,
    FormattedDate,
    lists: MASTER.Lists
};